const oneKB = 1000;

const fileSize = {
  oneGB: oneKB ** 3,
  oneMB: oneKB ** 2,
};

export default fileSize;
